import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetPlacesQuery } from 'features/place/services';
import { useMemo, useState } from 'react';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { OrdersColumns, useOrdersColumns } from '../constants/table-settings';
import { configureTableColumns } from 'utils/table-helpers';
import { useNavigate, useParams } from 'react-router-dom';
import { useWorkspace } from 'hooks/useWorkspace';
import useTable from 'hooks/useTable';

const useController = () => {
    const { placeId = '' } = useParams();
    const [activePlace, setActivePlace] = useState<string>(placeId);
    const { baseWorkspaceUrl, websiteId } = useWorkspace();
    const navigate = useNavigate();
    const { data: places } = useGetPlacesQuery({
        ...FETCH_ALL_PARAMS,
        website_id: websiteId,
    });
    const activePlaceTimeZone = places?.content?.find((p) => p.id === placeId)?.timeZone;

    const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
        setActivePlace(newValue);
        navigate(`../orders/${newValue}`);
    };

    const filterSelectOptions = useMemo(() => {
        if (!places) return {};

        return {
            placeName: mapToSelectOptions(places.content),
        };
    }, [places]);

    const { tableSettings } = useTable<OrdersColumns>({
        columns: configureTableColumns(useOrdersColumns(activePlaceTimeZone), filterSelectOptions),
        queryIdentifier: 'orders',
        enableRowActions: false,
        renderAddButton: false,
        onRowClick: (row) => navigate(`${baseWorkspaceUrl}/order/${placeId}/${row.id}`),
    });

    return { tableSettings, websiteId, places, placeId, activePlace, handleTabChange };
};

export default useController;
